import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import EmailForm from './EmailForm';

class TourManagerModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(values) {
    this.props.sendToTourManager(this.props.tour.id, values);
    this.props.onClose();
  }
  handleCancel(event) {
    event.preventDefault();
    this.props.onClose();
  }
  renderForm() {
    return (
      <Modal show={this.props.show} onHide={this.props.onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Share</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Invite someone to collaborate with you on this travel plan. The collaborators have
            read-only access to view hotels, routes, and particpants.
          </p>
          <EmailForm onSubmit={this.handleSubmit} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
  render() {
    return this.renderForm();
  }
}

TourManagerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  sendToTourManager: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default TourManagerModal;



// WEBPACK FOOTER //
// src/routes/tours/components/TourManagerModal.js